import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { Coordinates } from 'src/app/models/Coordinates';
import { Ope } from 'src/app/models/Ope';
import { PostionCoordinate } from 'src/app/models/PositionCoordinate';
import { DocServices } from 'src/app/services/docs/docs.services';
import { ImageCacheService } from 'src/app/services/imageCache.service';
import { OpeService } from 'src/app/services/ope/ope.service';
import { PersistanceService } from 'src/app/services/persistenceStorage/localstorage.service';

import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { CardComponent } from 'src/app/tableaux-listes/liste-cards/card/card.component';
import { CacheService } from 'src/app/services/cache.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {


  coordinates: Coordinates[] = [];
  compt: number = 0;
  //map!: google.maps.Map;
  center: google.maps.LatLngLiteral = { lat: 48.866667, lng: 2.333333 };
  geocoder: google.maps.Geocoder = new google.maps.Geocoder();
  markers = [];


  locations: PostionCoordinate[] = [];

  constructor(public share: shareOpeSevices, private docsndVigneteService: DocServices, private router: Router, private opeService: OpeService, private persist: PersistanceService, private imageCacheService: ImageCacheService, private cacheService: CacheService) {

  }

  ngOnInit(): void {
    if (this.share.initmap) {
      this.coordinates = []
      this.initMapo();
      this.share.initmap = false;
    }
    else {
      this.getMap(this.share.datasourceOpe.value);
    }
  }

  initMapo() {
    this.getLocations();
  }

  programmSelected!: Ope;

  openOpe(ope: Ope): void {
    const pageCard = new CardComponent(this.share, this.opeService, this.router, this.docsndVigneteService, this.persist, this.imageCacheService);
    pageCard.sendOpeclickOut(ope);
    /*this.share.datasOpe$.subscribe(data => {
      this.programmSelected = data;
    });*/

  }

  datas: Ope[] = [];
  getLocations() {

    this.share.datasourceOpe$.subscribe(
      {

        next: data => {
          this.coordinates = []
          this.getMap(data);
        }
      });
  }

  isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  contentInfoMap(info: Ope): string {
    let descriptionStatut = ((info.maxTypeLot !== info.minTypeLot) || (info.maxTypeLot !== '')) ? `Du ${info.minTypeLot} au ${info.maxTypeLot}` : "Du " + info.minTypeLot;
    let prixtodisplay = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(info.prixMin * 1.2);
    let moispre = info.dateLivraison.substring(5, 7);
    let yearpre = info.dateLivraison.substring(0, 4);
    let jourspre = info.dateLivraison.substring(8, 10);
    let date = `${jourspre}/${moispre}/${yearpre}`;
    let urlImageVig = "assets/images/placeholder-vignette.png";
    let vignetteope = JSON.parse(window.localStorage.getItem(info.nom) as string);
    if (vignetteope != null) {
      if (vignetteope.url) urlImageVig = vignetteope.url;
    }

    if (this.isMobile())
      return `<div id="content" style="padding: 12px;cursor: pointer;color:#000;width: 280px; box-sizing: border-box; font-family: Assistant, Arial, Helvetica, sans-serif; display: flex; flex-direction: column; justify-content: space-between;">
                  <div>
                  <h2 style="margin: 0; font-size: 1em; font-weight: bold;">${info.nom}</h2>
                  <p style="margin: 2px 0; font-size: 0.8rem; ">${info.ville} (${info.codePostal})</p>
                  </div>
                </div>`;

    else
      return `<div id="content"><img src="${urlImageVig}" style="pointer-events: none; cursor: pointer;color:#000;width: 280px;height:158px" >
                  <div style="padding: 12px;cursor: pointer;color:#000;width: 280px; box-sizing: border-box; font-family: Assistant, Arial, Helvetica, sans-serif; display: flex; flex-direction: column; justify-content: space-between;">
                  <div>
                  <h2 style="margin: 0; font-size: 1.5em; font-weight: bold;">${info.nom}</h2>
                  <p style="margin: 2px 0; font-size: 0.8rem; ">${info.ville} (${info.codePostal})</p>
                  <p style="font-size: 0.8rem; margin: 4px 0; ">${descriptionStatut} à partir de ${prixtodisplay}</p>
                  <p style="font-size: 0.8rem; margin: 2px 0;">Livraison : ${date}</p><br>
                  </div>
                  <div style="display: flex; justify-content: space-around; align-items: center; border-top: 1px solid #ccc; padding-top: 10px; font-size: .875em;">
                  <div style="text-align: center; flex: 1; border-right: 1px solid #ccc;">
                  <span>Total lots</span>
                  <strong style="display: block; font-size: 0.7rem; margin-top: 4px;">${info.totalLots}</strong>
                  </div>
                  <div style="text-align: center; flex: 1; border-right: 1px solid #ccc;color: #1e8c61;">
                  <span>Lots disponibles</span>
                  <strong style="display: block; font-size: 0.7rem; margin-top: 4px; ">${info.disponibles}</strong>
                  </div>
                  <div style="text-align: center; flex: 1;color: #f97316;">
                  <span>Options</span>
                  <strong style="display: block; font-size: 0.7rem; margin-top: 4px;">${info.optionnes}</strong>
                  </div>
                  </div>
                </div></div>`;
  }




  async getMap(data: Ope[]) {

    const { Map, InfoWindow } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;



    const infoWindow = new google.maps.InfoWindow({
      content: "",
      disableAutoPan: true,
    });
    //data.forEach(async a=>{


    //});
    //this.coordinates.length = 0;
    await this.codeAddress(data);
    let paris = { lat: 47.081012, lng: 2.398782 }
    let zoom = 5.6
    let mapTypeControl = false;
    let streetViewControl = false
    let panControl = false;
    let zoomControl = true;
    let scrollwheel = true;
    let scaleControl = true;
    let draggable = true;

    if (data.length === 1) {

      paris = this.coordinates[0].position;
      zoom = 15;
    }

    let mapoo = document.getElementById("mapo");
    if (mapoo == null) {
      mapoo = document.createElement('div');
      mapoo.setAttribute("id", "mapo");
    }
    const map = new google.maps.Map(
      mapoo as HTMLElement,
      {
        zoom: zoom,
        center: paris,
        mapId: 'MAP_EXTRANET',
        mapTypeControl: mapTypeControl,
        streetViewControl: streetViewControl,
        panControl: panControl,
        zoomControl: zoomControl,
        scrollwheel: scrollwheel,
        scaleControl: scaleControl,
        draggable: draggable,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      }
    );

    const markers = this.coordinates.map((pos) => {
      const ppose = pos.position;

      const label = "";

      let dispo = document.createElement('span');

      dispo.style.cssText = " display: flow; background: radial-gradient( 10px -9px, circle, white 8%, red 26px );    background-color: #008CFF;    border: 2px solid #008CFF;    border-radius: 12px; /* one half of ( (border * 2) + height + padding ) */    color: white;    font: 10px Helvetica, Verdana, Tahoma;    height: 23px;   width: 23px;    padding: 4px;    text-align: center;"
      dispo.textContent = "" + pos.ope.disponibles;

      /*const parser = new DOMParser();
      const pinSvgString = '<svg xmlns="http://www.w3.org/2000/svg" fill="#008CFF" viewBox="0 0 240 240" width="58" height="58" transform="translate(0 25)">	<circle cx="120" cy="120" opacity="1" r="50"></circle>	<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="40" dominant-baseline="middle" font-family="roboto,arial,sans-serif">'+pos.ope.disponibles+'</text></svg>';

      const pinSvg = parser.parseFromString(pinSvgString, 'image/svg+xml').documentElement;*/

      var marker: google.maps.MVCObject | google.maps.marker.AdvancedMarkerElement | null | undefined;
      if (data.length > 1) {
        marker = new google.maps.marker.AdvancedMarkerElement({
          //content: dispo,
          content: dispo,
          position: ppose,
        });
      } else {
        marker = new google.maps.marker.AdvancedMarkerElement({
          //content: dispo,
          position: ppose
        });
      }


      marker.addListener("gmp-click", () => {
        infoWindow.setContent(this.contentInfoMap(pos.ope));
        infoWindow.open(map, marker);
        infoWindow.addListener('domready', () => {
          document.getElementById("content")!.addEventListener("click", () => {
            this.openOpe(pos.ope);
          });
        });
        //google.maps.event.addListener(infoWindow, 'click', (function(){
        //  var div = document.getElementById('content');
        //  div!.onclick = function(){card = new CardComponent()};
        //}));
      });
      return marker;
    });

    const renderer = {
      render: ({ count, position }: { count: any, position: any }) =>
        new google.maps.Marker({
          label: { text: String(count), color: "white", fontSize: "10px" },
          position,
          icon: "assets/images/icons/m1.png",
          // adjust zIndex to be above other markers
          zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
        }),
    };
    const markerscluster = new MarkerClusterer({

      /*onClusterClick: (e, cluster) => {

        if (map.getZoom()) {
          const s = map.getZoom();
          map.setZoom(s! + 1);
          map.setCenter(cluster.position);
        }
      },*/
      markers,
      map, renderer
    });


    google.maps.event.addListener(markerscluster, 'clusterclick', (cluster: any) => {
      const bounds = cluster.getBounds();
      if (bounds) {
        map.fitBounds(bounds);
      }
      map.setCenter(cluster.position);
    })

  }


  async codeAddress(data: Ope[]) {

    for (const cdt of data) {

      if (cdt != null) {
        var cacheObj = this.cacheService.get(cdt.numOpe.toString());
        if (cacheObj) {
          this.locations.push(cacheObj.latLng);
          this.coordinates.push(cacheObj.coord);
        }
        else {
          await this.geocoder.geocode({ address: cdt.adresse1 + " " + cdt.ville }, (results, status) => {
            if (status === 'OK') {
              if (results != null) {
                var latLng = { lat: results?.[0].geometry.location.lat(), lng: results?.[0].geometry.location.lng() };
                var coord = new Coordinates(latLng, cdt.nom, "", cdt.adresse1 + " " + cdt.ville, cdt);
                this.locations.push(latLng);
                this.coordinates.push(coord);
                this.cacheService.set(cdt.numOpe.toString(), { latLng: latLng, coord: coord })
              }
            }
          });
        }
      }

    }
  }
}

